import { render, staticRenderFns } from "./ContactButton.vue?vue&type=template&id=71f0f250&scoped=true&lang=pug&"
import script from "./ContactButton.vue?vue&type=script&lang=ts&"
export * from "./ContactButton.vue?vue&type=script&lang=ts&"
import style0 from "./ContactButton.vue?vue&type=style&index=0&id=71f0f250&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f0f250",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GCardIcon from 'shared/global/components/CardIcon.vue'
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {GCardIcon,VBtn,VCard,VCardActions,VCardText,VCardTitle,VDivider})
